<app-alert-modal
  #subscriptionDuration
  [headerLabel]="modalHeader"
  [secondaryCancelBtnLabel]="labels.CANCEL"
  [confirmBtnLabel]="confirmBtnDynamicLabel"
  dynamicClass="subscription-plan-duration-container"
  (canceled)="handleCancel()"
  (confirmed)="subscribePlan()"
  [modalOptions]="modalOptions"
>
  <div class="d-flex flex-column c-gap-30 text-left sub-plan-duration">
    <div class="modal-header-label">
      {{
        messages.TO_UNLOCK_OFFER_SUBSCRIBE_PLAN.replace(
          '[content]',
          (headerType || contentType).toUpperCase()
        )
          .replace('[name]', fullName)
          .replace('[planName]', curSelectedSubscription?.name)
      }}
    </div>
    <app-profile-detail [userProfile]="userProfile"></app-profile-detail>
    <div class="modal-subscribe-get">
      <p>{{ curSelectedSubscription?.name }} &nbsp;{{ labels.BENEFITS }}:</p>
      <div>
        <ul class="pad-0">
          <li *ngFor="let feature of curSelectedSubscription?.features">
            <span>{{ feature }}</span>
          </li>
          <div *ngIf="curSelectedSubscription?.free_dms_count">
            <div class="free-dms-badge">
              <span>
                <em class="icon-litefree-dms-count"></em>
                <ng-container *ngIf="curSelectedSubscription?.is_unlimited_free_dms; else finiteDms">
                  {{ Application.FREE_DIRECT_MESSAGES_PER_MONTH.replace('[quantity]', Application.UNLIMITED) }}
                </ng-container>
                <ng-template #finiteDms>
                  {{ Application.FREE_DIRECT_MESSAGES_PER_MONTH.replace('[quantity]', curSelectedSubscription?.free_dms_count) }}
                </ng-template>
              </span>
            </div>
          </div>
        </ul>
        <div class="modal-susbcribeDuration">
          <p>{{ labels.SELECT_DURATION }}</p>
          <div class="modal-susbcribeList">
            <ng-container
              *ngFor="let plan of curSelectedSubscription?.plan_details"
            >
              <app-button
                [btnField]="durationBtnField(plan)"
                (handleButtonClick)="selectPlan(plan)"
              ></app-button>
            </ng-container>
          </div>
        </div>
        <div class="modal-subscribePrice">
          <p>
            {{ labels.PRICE_FOR }}
            {{ getDurationLabel(selectedPlan) }}
          </p>
          <h5>
            ${{ selectedPlan?.price | priceDiscount: selectedPlan?.discount }}
            <span
              *ngIf="selectedPlan?.discount && selectedPlan?.discount !== '0'"
            >
              {{
                messages.DISCOUNT_PERCENT_OFF.replace(
                  '[discount]',
                  selectedPlan?.discount
                )
              }}
            </span>
          </h5>
        </div>
      </div>
    </div>
  </div>
</app-alert-modal>
